<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
body,html,h3,.elcard{
margin: 0px;
padding: 0px;
}

.el-popper.is-light,
.el-select-dropdown,
.el-picker__popper {
  color: #eef4ff !important;
  border-color: #29465b !important;
  background: #0b1828 !important;
}

.el-select-dropdown__item {
  color: rgba(238, 244, 255, 0.78) !important;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #ffffff !important;
  background: #173149 !important;
}

.el-select-dropdown__item.selected {
  color: #071321 !important;
  background: #8ed7ff !important;
  font-weight: 800;
}

.el-select .el-select__caret,
.el-select .el-select__clear {
  color: #8ed7ff !important;
}

.el-message,
.el-message-box__wrapper,
.el-overlay-message-box {
  z-index: 120000 !important;
}

</style>
